import styled from 'styled-components';
import ClearButton from './ClearButton';

const TransparentButton = styled(ClearButton)`
  height: 40px;
  background-color: transparent;
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 0;
  width: 100%;
  max-width: unset;
`;

export default TransparentButton;
